import '.dv{padding:16px;}.ssr-plugin'
import '.u{border-radius:16px;}.ssr-plugin'
import '.gu{max-width:404px;}.ssr-plugin'
import '.ap{position:relative;}.ssr-plugin'
import '.o{display:flex;}.ssr-plugin'
import '.cb{gap:12px;}.ssr-plugin'
import '.gv{overflow-wrap:anywhere;}.ssr-plugin'
import '.dc{word-break:break-word;}.ssr-plugin'
import '.b2{min-width:0px;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { colors } from '../utils/colors.js'
import { transparentColor } from '../utils/transparentcolor.js'

type NoteProps = {
  leadIcon?: React.ReactNode
  color?: 'orange' | 'red'
  children: React.ReactNode
  style?: Style
}

export const Note = ({ leadIcon, color, children, style }: NoteProps) => {
  return (
    <styled.div className="blur dv u gu ap o cb"
      style={{
        backgroundColor:
          color === 'red'
            ? transparentColor(colors.red, 0.15)
            : transparentColor(colors.orange, 0.15),
        border:
          color === 'red'
            ? `1px solid ${transparentColor(colors.red, 0.15)}`
            : `1px solid ${transparentColor(colors.orange, 0.15)}`,
        color: color === 'red' ? colors.red : colors.orange,
        ...style,
      }}
    >
      {leadIcon ? <span>{leadIcon}</span> : null}
      <p className="gv dc b2"
      >
        {children}
      </p>
    </styled.div>
  )
}
